
export const getCategory = (image_category) => {
    if (
      image_category?.toLowerCase() === "exterior" ||
      image_category?.toLowerCase() === "360_exterior"
    ) {
      return "exterior";
    } else if (image_category?.toLowerCase() === "interior") {
      return "interior";
    } else {
      return "additional";
    }
  };